import { DataConversionUserSetting } from '../models/data-conversion-user-setting.model';
import { Precision } from '../models/precision.model';
import { ValueType } from '../models/value-type.model';
import { PrecisionBaseService } from '../services/precision-base.service';

export class PrecisionService extends PrecisionBaseService {
  constructor() {
    super();
  }

  async convert(_query: {
    value: number;
    valueType?: ValueType;
    sourceUnit?: string;
    sensorPrecision?: number;
    userSettingsDataConversions: DataConversionUserSetting[];
    tenantPrecision: Precision[];
  }): Promise<number | undefined> {
    const { value, valueType, sourceUnit, sensorPrecision, userSettingsDataConversions, tenantPrecision } = _query;

    if (typeof value !== 'number') {
      return undefined;
    }

    if (valueType && sourceUnit) {
      const basePrecision = (await this.loadPrecision(valueType, tenantPrecision, userSettingsDataConversions, sourceUnit)) || 0;

      const precision = sensorPrecision ? +basePrecision + +sensorPrecision : basePrecision;
      return this.applyPrecision(value, precision);
    }
    return this.applyPrecision(value, sensorPrecision);
  }

  convertSync(_query: { value: number; sensorPrecision?: number }): number | undefined {
    const { value, sensorPrecision } = _query;

    if (typeof value !== 'number') {
      return undefined;
    }
    return this.applyPrecision(value, sensorPrecision);
  }

  private async loadPrecision(
    valueType: ValueType,
    tenantPrecision: Precision[],
    userSettingsDataConversions: DataConversionUserSetting[],
    sourceUnit?: string,
  ): Promise<number | undefined> {
    if (userSettingsDataConversions?.length > 0) {
      return this.findPrecision(userSettingsDataConversions, tenantPrecision, valueType, sourceUnit);
    }
    return undefined;
  }
}
